// Typelizer digest 3ee182e0facf60c390ae901c22b7cf20
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /accountant/firm/assignments */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/accountant/firm/assignments', {}, options),
    method: 'post',
  }),

  /** DELETE /accountant/firm/assignments/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/accountant/firm/assignments/:id', params, options),
    method: 'delete',
  }),
}
